const LoginRules = {
    userName: [{ required: true, message: "Username is required" }],
    password: [{ required: true, message: "Password is required" }]
};

export default LoginRules;
